"use strict";
// import {http} from '../core';
import http from '../core/utils/request'
import {setSidebarMenu} from '../core'
import Config from "../app.config";
const RequestService = http.create();
const RequestAuth=http.create({baseURL:Config.AuthUrl})

const RequsetServiceCICD=http.create({baseURL:Config.BASEURL})
const BASE_API = Config.BASE_API;
const RequsetSseurl=http.create({baseURL:Config.sseurl})

export default {
    // 根据关键字获取知识列表
    getList:function (params) {
        return RequestService.get("knowledge/query",params);
    },
    // 数据字典(全部)
    dictionary:function () {
        return RequestService.get("data/dictionary")
    },
    //数据字典(CICD)
    dictionary2:function(){
        return RequsetServiceCICD.get("appcenter/apptree/v1/data/dictionary")
    },
    // 上传图片，上传附件
    uploading:function (params) {
        return RequestService.post(BASE_API+"fastdfs/v1/upload",params,null,true);
    },
    // 获取所属公司
    companyList:function () {
        return RequestService.get("organization/company/list");
    },
    //获取涉及数据库
    dataBase:function(){
        return RequestService.get('cmdb/all_db')
    },
    // 获取所有的分类
    getCaseType:function () {
        return RequestService.get("data/case_type");
    },
    // 分类
    categoryList:function (typeId) {
        return RequestService.get("category/type/list/all",{ type:typeId });
    },
    // 事件列表
    getEventList:function (params) {
        return RequestService.get("event/list",params);
    },
    // 获取配置项列表
    getConfigList:function (params) {
        return RequestService.get("cmdb/list",params);
    },
    //获取全部应用列表（有关键字搜索功能）
    getAppList:function(params){
        return RequsetServiceCICD.get('appcenter/apptree/v1/app/search/list',params)
    },
    //获取服务列表
    getServiceList:function (params) {
        return RequestService.get("service/list",params);
    },
    //获取SLA列表
    getSlaList:function(params){
        return RequestService.get('service/sla/list',params)
    },
    // 问题列表
    getProblemList:function (params) {
        return RequestService.get("problem/list",params);
    },
    // 变更列表
    getChangeList:function (params) {
        return RequestService.get("change/list",params);
    },
    // 发布列表
    getDeployList:function (params) {
        return RequestService.get("deploy/list",params);
    },
    //变更类型
    getChangeType:function (params) {
        return RequestService.get("data/dictionary",params)
    },
    // 获取服务组
    getDepartmentList:function (params) {
        return RequsetServiceCICD.get('itsm/v2/organization/department/tree/children',params)
    },
    // 用户列表
    getAllUser:function (params) {
        return RequsetServiceCICD.get('itsm/v2/organization/user/list',params);
    },
    //获取用户详情
    getUserDetail:function(params){
        return RequestService.post('organization/user/detail',params)
    },
    // 事件指派
    eventHandle:function (params) {
        return RequestService.post('event/handle',params);
    },
    //问题指派
    problemHandle:function(params){
      return RequestService.post('problem/handle',params)
    },
    //变更指派
    changeHandle:function (params) {
        return RequestService.post('change/handle',params);
    },
    //发布指派
    deployHandle:function (params) {
        return RequestService.post('deploy/handle',params);
    },
    // 根据组获取组人员
    getUserListByDepartment:function (params) {
        return RequsetServiceCICD.post('itsm/v2/organization/user/group_user',params);
    },
    //资源类型列表
    getResourceTypeList(){
        return RequestService.get('resource_appl/resource_type/list')
    },
    //提交操作时请求detail
    getCorrectDetail:function (params) {
        let sn=params.serialNumber
        // console.log('fffff');
        if (sn.indexOf('Eve')>-1) {
           return RequestService.get('event/detail',params)
        }
        if (sn.indexOf('Cha')>-1){
            return RequestService.get('change/detail',params)
        }
        if (sn.indexOf('Dep')>-1){
            return RequestService.get('deploy/detail',params)
        }
        if (sn.indexOf('Pro')>-1){
            return RequestService.get('problem/detail',params)
        }
        if (sn.indexOf('Cmd')>-1){
            return RequestService.get('cmdb/describe',params)
        }
        if (sn.indexOf('Kno')>-1){
            return RequestService.get('knowledge/detail',params)
        }

    },
    // 流程图
    flowChart:function (serialNumber) {
        return RequestService.get('flowChart',{serialNumber:serialNumber})
    },
    // 根据Id 获取组名
    groupDetail:function (groupId) {
        return RequestService.get('organization/group/detail',{ groupId:groupId });
    },
    // 设置工时
    addWork:function (params) {
        return RequestService.post("worker/add",params)
    },
    // 繁忙度统计---组繁忙度
    busynessGroup:function (departmentId) {
        return RequestService.get("organization/group/busyness",{ departmentId:departmentId })
    },
    // 繁忙度统计---人员繁忙度
    busynessUser:function (userId) {
        // return RequestService.get("organization/user/busyness",{ userId:userId })
        return RequsetServiceCICD.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    },
    // 我的待办
    getMyAgencyList:function (params) {
       return RequestService.get("home/my_agency",params);
    },
    // 我的待办全部数据长连接
    getMyAgencyUncompleted:function (params) {
        return RequsetSseurl.get("/v1/home/my_agency_uncompleted",params);
    },
    // 工时删除
    getWorkHoursDel:function (params) {
       return RequestService.post("worker/delete",params);
    },

    //动态获取权限(用app_name和user_id获取)
    getAuth(params){
        return RequestAuth.get('menu/get_menu',params).then(res=>{
            // console.log(res,'打印获取到的权限');
            setSidebarMenu(res.menu_data)
            let data={...res}
            setSidebarMenu(data.menu_data)
            let params=[
                {
                    path: "/login",
                    name: "login",
                    component: "/login/Login"
                    // component: "/login_itsm/Login"
                },

                // {
                //     path: "/register",
                //     name: "Register",
                //     component: "/login/register"
                // },
                // {
                //     path: "/forget",
                //     name: "Forget",
                //     component: "/login/forget"
                // },
                {
                    path: "/",
                    component: "/Home",
                    // redirect: "/index",
                    children: []
                },
                { path: "*", redirect: "/" }
            ];
            params[1].children=res.route_data
            data.route_data=params
            // console.log(data,'路由表处理后的权限');
            return Promise.resolve(data)
        },error => {
            // console.log(error,'路由获取错误啦');
            let data={}
            let params=[
                {
                    path: "/login",
                    name: "login",
                    component: "/login/Login"
                    // component: "/login_itsm/Login"
                },
                {
                    path: "/",
                    component: "/Home",
                    // redirect: "/index",
                    children: []
                },
                { path: "*", redirect: "/" }
            ];
            // params[3].children=res.route_data
            data.route_data=params
            // console.log(data,'获取路由失败后默认设置的路由');
            return Promise.resolve(data)
            // this.$router.replace('login');
            // this.$router.push({path:'/login'})
            // location.reload()
        })
    },
}
